export const CREATE_POLL = 'CREATE_POLL';
export const EDIT_POLL = 'EDIT_POLL';
export const CANCEL_EDIT_POLL = 'CANCEL_EDIT_POLL';
export const SAVE_POLL = 'SAVE_POLL';
export const DELETE_POLL = 'DELETE_POLL';
export const ADD_RESPONSE = 'ADD_RESPONSE';
export const SET_VOTED = 'SET_VOTED';



// WEBPACK FOOTER //
// ./assets/es6/view_invitation/polls/constants.es6